import { gql } from '@apollo/client';

export const UPDATE_QUERY_RETURN = gql`
  mutation updateQueryReturn($input: UpdateQueryReturnInput!) {
    updateQueryReturn(input: $input) {
      errors
      incidentUuid
      queryReturn {
        id
        read
      }
    }
  }
`


// {
//   "input":{
//     "originatorId": 21,
// 		"incidentId": null,
// 		"queryKey": "SVQ",
// 		"ORI": "SP",
// 		"DAC": "dac",
// 		"USR": "rraabe",
// 		"PWD": "test",
// 		"DST": "VT",

// 		"NAM": null,
// 		"DOB": null,
// 		"SEX": null,
// 		"PID": null,
// 		"OCF": null,
// 		"OLN": null,
// 		"RSN": null,
// 		"PPS": null,
// 		"LIC": null,
// 		"LIY": null,
// 		"LIT": null,
// 		"VIN": null,
// 		"VMA": null,
// 		"VYR": null,
// 		"SNM": null,
// 		"SDX": null
//   }
// }